import { render, staticRenderFns } from "./marque_list.vue?vue&type=template&id=4a078ffc&"
import script from "./marque_list.vue?vue&type=script&lang=js&"
export * from "./marque_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports